<template>
  <div class="container py-5">

    <p>
    TSK 將參與 2024台灣醫用雷射光電學會-秋季學術研討會！<br><br>TSK醫美尖針與鈍針，融合日本製造的高品質與工匠精神，為醫美行業帶來安全、精準且舒適的使用體驗。展會現場將展示多款TSK針頭的型號規格，歡迎親臨攤位體驗TSK針頭的卓越手感。<br><br><b>🌟 好康加碼 1 🌟</b><br> 當天蒞臨TSK攤位，完成蓋章集點活動與指定條件，即可參與由“台灣醫用雷射光電學會”舉辦的「iPhone 16 與 TSK尖針鈍針 抽獎活動」！<br><br><b>🌟 好康加碼 2 🌟</b><br> 歡迎至TSK現場攤位參與「展會限定-幸運轉轉盤活動」贏取更多專屬優惠！<br>驚喜獎品包含產品折扣、贈品組合等多重優惠，祝您轉出好運，帶回驚喜！ <br><br>現場更多優惠與活動等您來發現，不要錯過⮕<br>展會時間：2024年10月27日(日)<br> 展會地點：華南銀行國際會議中心<br> 攤位編號：9
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_47.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
